import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface SettingsFactProps {
  label: ReactNode;
  /** Empty values render an em dash rather than a fake disabled input. */
  value?: ReactNode;
  /** Right slot, normally a `StatusPill`. */
  trailing?: ReactNode;
  /** 12px muted note under the value. */
  hint?: ReactNode;
  /** Add `tabular-nums` here for dates and counts. */
  valueClassName?: string;
  className?: string;
}

function isEmpty(value: ReactNode): boolean {
  return value === null || value === undefined || value === '';
}

/** Read-only label/value row for facts with no self-serve mutation. */
export function SettingsFact({
  label,
  value,
  trailing,
  hint,
  valueClassName,
  className,
}: SettingsFactProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <div className="text-sm font-bold leading-5 text-white">{label}</div>
      <div className="flex min-w-0 items-center justify-between gap-3">
        <div
          className={cn(
            'min-w-0 break-words text-sm leading-5',
            isEmpty(value) ? 'text-seeker-400' : 'text-white',
            valueClassName,
          )}
        >
          {isEmpty(value) ? '—' : value}
        </div>
        {trailing}
      </div>
      {hint ? (
        <div className="text-xs leading-4 text-seeker-400">{hint}</div>
      ) : null}
    </div>
  );
}
